import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [consent, setConsent] = useState(false);

  // Hydrate from token on mount. setUser/setLoading are stable; api is a module
  // singleton — intentionally not in deps to run exactly once on mount.
  useEffect(() => {
    const t = localStorage.getItem("mf_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => {
        console.warn("auth: stale token, clearing", err?.response?.status);
        localStorage.removeItem("mf_token");
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("mf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("logout: server call failed; clearing local state anyway", err?.message);
    }
    localStorage.removeItem("mf_token");
    setUser(null);
    setConsent(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, logout, consent, setConsent }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
